import { OnboardingHighlightWrapper } from '@sorare/core/src/components/onboarding/OnboardingHighlightWrapper';
import { Cost as DumbCost } from '@sorare/core/src/components/player/Cost';

type Props = { onboarding?: boolean } & React.ComponentProps<typeof DumbCost>;
export const Cost = ({ onboarding, ...rest }: Props) => {
  return (
    <OnboardingHighlightWrapper
      wrap={!!onboarding}
      highlightName="RivalsDraftCost"
      config={{ circle: true, padding: 12, border: true }}
    >
      <DumbCost {...rest} />
    </OnboardingHighlightWrapper>
  );
};
